import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {TextBuiltInControl} from '../TextBuiltInControl';

/**
 * @description base class including text style modifications logic
 */
export abstract class TextStyleBuiltInControl extends TextBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes.GENERAL.TEXT_STYLE;
  }
}
